import * as React from 'react';

export interface IPaymentSettingsProps {
}

export function PaymentSettings(props: IPaymentSettingsProps) {
    return (
        <div className="text-left mt-8 payment_settings_main_box">
            <h1 className="text-xl sm:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white">Payment Settings</h1>
            <p className="text-cusBlack dark:text-white text-xl mt-2">Accept card payments</p>
            <p className="text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2 w-10/12 ">Complete the verification steps below to accept card payments for your listings, using Moonpay. <br /> Moonpay is required to collect certain information to use their services. This information is not stored by OpenSea.</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4 mt-10">

                <div className="p-8 rounded-lg lightBlueBg flex flex-col justify-between">
                    <div>
                        <p className="text-cusBlack dark:text-white text-xl">Basic verification</p>
                        <p className="text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2 ">
                            Buy or sell up to $7,500 worth of NFTs through card payments with Moonpay.
                        </p>

                        <li className="text-l-LightBlack dark:text-[#8987AF] text-xs lg:text-base mt-5">Name</li>
                        <li className="text-l-LightBlack dark:text-[#8987AF] text-xs lg:text-base ">Date of Birth</li>
                        <li className="text-l-LightBlack dark:text-[#8987AF] text-xs lg:text-base ">Residence</li>
                    </div>

                    <div className="w-full text-right">
                        <button className="bg-[#EFEFEF] dark:bg-[#423D85] px-5 text-xs sm:text-base py-3 rounded-md text-cusBlack dark:text-white mt-5 begain_btn">
                            <p>Begin</p>
                        </button>
                    </div>
                </div>



                <div className="p-8 rounded-lg lightBlueBg flex flex-col justify-between">
                    <div>
                        <p className="text-cusBlack dark:text-white text-xl">Advanced verification</p>
                        <p className="text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2 ">
                            Buy or sell NFTs with no lifetime limits
                        </p>

                        <li className="text-l-LightBlack dark:text-[#8987AF] text-xs lg:text-base mt-5">Advanced customer verification</li>
                        <li className="text-l-LightBlack dark:text-[#8987AF] text-xs lg:text-base ">ID Verification</li>
                    </div>

                    <div className="w-full text-right">
                        <button className="bg-[#EFEFEF] dark:bg-[#423D85] px-5 text-xs sm:text-base py-3 rounded-md text-cusBlack dark:text-white mt-5 begain_btn">
                            <p>Begin</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
